import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Typography,
} from '@mui/material';

const BasicInfoForm = ({
  formData,
  onInputChange,
  accounts,
  crmCampaigns,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth required>
          <InputLabel>Account</InputLabel>
          <Select
            name="account"
            value={formData.account}
            onChange={onInputChange}
            label="Account"
          >
            {accounts.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                {account.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControl fullWidth required>
          <InputLabel>CRM Campaign</InputLabel>
          <Select
            name="crm_campaign"
            value={formData.crm_campaign}
            onChange={onInputChange}
            label="CRM Campaign"
            disabled={!formData.account}
          >
            {crmCampaigns.map((campaign) => (
              <MenuItem key={campaign.id} value={campaign.id}>
                {campaign.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          required
          label="Campaign Name"
          name="name"
          value={formData.name}
          onChange={onInputChange}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Description"
          name="description"
          value={formData.description}
          onChange={onInputChange}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label="Start Date"
          name="start_date"
          type="date"
          value={formData.start_date}
          onChange={onInputChange}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          label="End Date"
          name="end_date"
          type="date"
          value={formData.end_date}
          onChange={onInputChange}
          disabled={formData.is_ongoing}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <Switch
              checked={formData.is_ongoing}
              onChange={onInputChange}
              name="is_ongoing"
            />
          }
          label="Ongoing Campaign"
        />
        <Typography variant="caption" color="textSecondary" display="block">
          If enabled, the campaign will run indefinitely
        </Typography>
      </Grid>
    </Grid>
  );
};

export default BasicInfoForm; 